export default {
    nav: {
        dashboard:     'Control room',
        shifts:        'Daily log',
        tickets:       'Fault reports',
        faults:        'Faults',
        incidents:     'Fault resolution help',
        plan:          'Delivery plan',
        reports:       'Reports',
        guide:         'User guide',
        electricity:   'Electricity use',
        personnel:     'Workers & teams',
        reference:     'Suppliers & materials',
        schedule:      'Operating schedule',
        field_bounds:  'Quality bounds',
        users:         'Users',
    },
    app: {
        name:    'XRT',
        company: 'Meltal Group',
    },
    theme: {
        system: 'System theme',
        light:  'Light theme',
        dark:   'Dark theme',
    },
    nav_groups: {
        production:  'Production',
        maintenance: 'Maintenance',
        data:        'Data',
        admin:       'Administration',
    },
    electricity: {
        title:                  'Electricity use',
        meter_banot:            'Electricity use - Banot',
        meter_linija:           'Electricity use - Line',
        previous_reading:       'Previous reading',
        no_previous_reading:    'No previous entry yet.',
        current_reading:        'Current meter reading',
        consumption:            'Use this month',
        reminder:               "Today is the last day of the month — enter this month's electricity meter readings (Banot and line).",
        reminder_action:        'Enter readings',
    },
    tickets: {
        title:              'Fault reports',
        new_placeholder:    'E.g. Conveyor P28 fan wheel needs replacing ...',
        priority:           'Priority',
        priority_high:      'High',
        priority_medium:    'Medium',
        priority_low:       'Low',
        status:             'Status',
        status_open:        'Open',
        status_in_progress: 'In progress',
        status_resolved:    'Resolved',
        reported_by:        'Reported by',
        resolved_by:        'Resolved by',
        resolution_note:    'Resolution note',
        resolution_note_placeholder: 'What was done (optional) ...',
        mark_in_progress:   'In progress',
        mark_resolved:      'Resolved',
        reopen:             'Reopen',
        report:             'Report',
        delete:              'Delete',
        confirm_delete:     'Delete this report?',
        filter_all_priorities: 'All priorities',
        pending_section:    'Waiting for work',
        resolved_section:   'Resolved',
        empty:              'No open reports right now.',
        empty_resolved:     'No resolved reports yet.',
    },
    faults: {
        phrases: [
            'repair on the Banot',
            'knife and counter-knife change',
            'RTG fault, restart',
            'tightening bolts',
            'pusher roller replacement',
        ],
        title:           'Faults',
        shift:           'Operating cycle',
        start_at:        'Start',
        end_at:          'End',
        description:     'Fault description',
        duration:        'Duration',
        delete:          'Delete',
        confirm_delete:  'Delete this fault record?',
        new:             'New fault',
        edit:            'Edit fault',
    },
    incidents: {
        title:           'Fault resolution help',
        new:             'New incident',
        detail:          'Incident details',
        list_title:      'Title',
        date:            'Date',
        component:       'Component',
        description:     'What happened',
        cause:           'Cause',
        resolution:      'How it was resolved',
        resolved_by:     'Resolved by',
        status:          'Status',
        downtime_hours:  'Line downtime (h)',
        status_open:            'Open',
        status_in_progress:     'In progress',
        status_resolved:        'Resolved',
        search:          'Search title, description, cause, resolution ...',
        save:            'Save',
        delete:          'Delete',
        confirm_delete:  'Delete this incident?',
    },
    reference: {
        title:          'Suppliers & materials',
        suppliers:      'Suppliers',
        materials:      'Materials',
        name:           'Name',
        active:         'Active',
        new_supplier:   'New supplier',
        new_material:   'New material',
        edit:           'Edit',
    },
    personnel: {
        title:              'Workers & teams',
        workers:            'Workers',
        teams:              'Teams',
        rotation:           'Weekly rotation',
        roster_exceptions:  'Roster exceptions',
        roster_preview:     'Roster preview',
        name:               'Name',
        team:               'Team',
        active:             'Active',
        operator:           'Operator',
        operators:          'Operators',
        bulk_add:           'Add several workers',
        bulk_help:          'Paste a list of names (one per line). Lines with hours such as 149:40 are skipped, and existing names are not duplicated.',
        bulk_result:        'Added: {added}, skipped (already exist): {skipped}',
        new_worker:         'New worker',
        new_team:           'New team',
        effective_from:     'Effective from (Monday)',
        reference_week_start: 'Reference week (Monday)',
        team_morning:       'Morning team',
        team_afternoon:     'Afternoon team',
        new_rule:           'New rotation rule',
        week_start:         'Week (Monday)',
        scope:              'Exception type',
        scope_team_swap:    'Swap whole teams',
        scope_worker:       'Single worker',
        worker:             'Worker',
        shift_field:        'Shift',
        morning:            'Morning',
        afternoon:          'Afternoon',
        note:               'Note',
        new_exception:      'New exception',
        select_date:        'Pick a date',
        not_defined:        'No roster is defined yet for the selected week.',
        delete:             'Delete',
    },
    reports: {
        title:                  'Reports',
        year:                   'Year',
        month:                  'Month',
        annual:                 'Annual',
        total_input_qty_kg:     'Total input (kg)',
        total_good_pieces_kg:   'Total good pieces (kg)',
        total_gross_hours:      'Total gross hours',
        total_effective_hours:  'Total effective hours',
        total_fault_hours:      'Total fault hours',
        scheduled_hours:        'Scheduled hours',
        capacity_utilization:   'Capacity utilization',
        throughput_effective:   'Throughput / effective hour',
        throughput_gross:       'Throughput / gross hour',
        target_achievement:     'Target achievement',
        shift_count:            'Cycle count',
        electricity:            'Electricity consumption (kWh)',
        plan_vs_actual:         'Delivery plan vs. actual',
        supplier:               'Supplier',
        material:               'Material',
        planned:                'Planned (kg)',
        actual:                 'Actual (kg)',
        difference:             'Difference (kg)',
        export:                 'Export daily log',
        export_csv:             'Export CSV',
        export_xlsx:            'Export Excel',
    },
    plan: {
        status_expected:  'Expected',
        status_partial:   'Partially delivered',
        status_delivered: 'Delivered',
        status_delayed:   'Delayed',
        targets:          'Annual and monthly target',
        annual_target:    'Annual target (kg)',
        monthly_target:   'Monthly target (kg)',
        save:             'Save',
    },
    schedule: {
        title:          'Operating schedule',
        versions:       'Schedule versions',
        exceptions:     'Date exceptions',
        effective_from: 'Effective from',
        weekly:         'Weekly template',
        working:        'Working',
        start_time:     'Start',
        end_time:       'End',
        date:           'Date',
        note:           'Note',
        new_version:    'New version',
        new_exception:  'New exception',
        delete:         'Delete',
        confirm_delete: 'Delete this exception?',
    },
    field_bounds: {
        title:       'Data quality bounds',
        field:       'Field',
        min:         'Lower bound',
        max:         'Upper bound',
        source:      'Source',
        manual:      'Manual',
        computed:    'Automatic',
        reset:       'Reset to automatic',
        save:        'Save',
    },
    users: {
        title:       'Users',
        name:        'Name',
        username:    'Username',
        role:        'Role',
        active:      'Active',
        password:    'Password',
        new_password: 'New password (leave blank to keep unchanged)',
        new_user:    'New user',
        role_entry:  'Entry',
        role_admin:  'Admin',
        role_viewer: 'Viewer',
        pin:         'PIN (4 digits)',
        pin_invalid: 'PIN must be exactly 4 digits',
        reset_pin:   'Reset PIN',
    },
    shifts: {
        title:            'Daily log',
        new:              'New entry',
        detail:           'Details',
        start_at:         'Start',
        end_at:           'End',
        supplier:         'Supplier',
        material:         'Material',
        input_qty_kg:     'Material input (kg)',
        good_pieces_kg:   'Good output (kg)',
        gross_hours:      'Gross hours',
        effective_hours:  'Effective hours',
        electricity_meter_start: 'Electricity meter - start',
        electricity_meter_end:   'Electricity meter - end',
        notes:            'Notes',
        save:             'Save',
        outside_schedule: 'This cycle partly falls outside the operating schedule.',
        photos:           'Photos',
        add_photo:        'Add photo',
        section_input:       'Material input',
        section_output:      'Material output',
        section_electricity: 'Electricity consumption',
        section_time:        'Operating time',
        operators:           'Machine operators',
        no_operators:        'No operators yet — add them under Workers & teams.',
        section_faults:      'Fault log during this cycle',
        workers_count:       'Sorters on the line',
        sorter_hours:        'Sorting hours (h)',
        cleaning_hours:      'Line cleaning (h)',
        maintenance_hours:   'Maintenance (h)',
        output_waste:               'Waste (kg)',
        output_fe:                  'Iron (Fe) (kg)',
        output_inox:                'Inox (kg)',
        output_mix_sheet:           'Mixed sheet (kg)',
        output_hard_clean:          'Hard clean (kg)',
        output_hard_fe:             'Hard FE (kg)',
        output_profiles_hute:       'Furnace profiles (kg)',
        output_mix_sheet_weighed:   'Mixed sheet - weighed (kg)',
        output_almg:                'AlMg (kg)',
        output_shoot:               'Shoot (kg)',
        output_shavings_pre_mill:   'Shavings before mill (kg)',
        output_filter_dust:         'Filter dust (kg)',
        output_shavings_post_mill:  'Shavings after mill (kg)',
        output_exceeds_input: 'Good pieces exceed material input — check the entry.',
        add_material:     'Add material',
        quantity_kg:      'Quantity (kg)',
        other_material:      'Other (type it in)',
        other_material_name: 'Material name',
        faults_help:      'Enter them right here, on the spot — no separate step.',
        no_faults:        'No faults entered for this cycle.',
        add_fault:        'Add fault',
        fault_duration_hours: 'Duration (h)',
        quick_fault:      'or add a common one:',
        end_before_start: 'End must be after the start.',
        meter_end_before_start: 'The ending meter reading cannot be lower than the starting one.',
        warning_input_out_of_range: 'Material input is off from the usual range — check the entry.',
        warning_good_out_of_range:  'Good output is off from the usual range — check the entry.',
        warning_electricity_out_of_range: 'Electricity use is off from the usual range — check both meter readings.',
        warning_output_mismatch: 'Total output is well above the material input — check the entry.',
        fault_needs_description: 'Enter a description for the fault.',
        fault_needs_duration:    'Enter a fault duration greater than 0.',
        entered_by:           'Entered by',
        trace:                'Traceability',
        trace_created:        'Entered by',
        trace_edited:         'Last changed',
        trace_history:        'Change history',
        trace_history_none:   'No changes recorded.',
        trace_field:          'Field',
        trace_old:            'Before',
        trace_new:            'After',
        trace_by:             'By',
        trace_when:           'When',
        existing_faults:      'Faults entered for this cycle',
        fault_correction:     'Correction to a past entry',
        fault_correction_help: 'If a fault was forgotten or entered incorrectly, you can add, edit or delete it even after the cycle was saved.',
        save_changes:         'Save changes',
    },
    dashboard: {
        title:              'Control room',
        logout:             'Sign out',
        go_to_shifts:       'Daily log',
        fullscreen:         'Fullscreen',
        exit_fullscreen:    'Exit fullscreen',
        new_entry_sub:      'Supplier, material, output, hours and faults in one place',
        ytd_output:         'Processed this year',
        month_output:       'Processed this month',
        utilization:        'Line utilization',
        today_so_far:       'Today so far',
        on_duty:            'On duty today',
        morning_shift:      'Morning',
        afternoon_shift:    'Afternoon',
        trend_14_days:      'Last 14 days',
        record_entry:       'Largest entry this year',
        no_target:          'No target set',
        no_roster:          'No roster defined for today',
        effective_hours:    'effective hours',
    },
    login: {
        title:        'Sign in',
        username:     'Username',
        password:     'Password',
        submit:       'Sign in',
        error:        'Invalid username or password',
        pick_who:     'Choose who you are',
        no_operators: 'No workers are currently available to sign in.',
        enter_pin:    'Enter your 4-digit code',
        wrong_pin:    'Wrong code',
        choose_pin:   'Choose your code',
        choose_pin_help: 'This is your first sign-in: replace the starting code with your own 4-digit code.',
        confirm_pin:  'Repeat the new code',
        pins_differ:  'The codes do not match, try again.',
        pin_same_as_old: 'The new code must differ from the starting one.',
        admin_login:  'Sign in as administrator',
    },
    general: {
        add:     'Add',
        edit:    'Edit',
        cancel:  'Cancel',
        save:    'Save',
        delete:  'Delete',
        confirm: 'Confirm',
        yes:     'Yes',
        no:      'No',
        search:  'Search',
        from:    'From',
        to:      'To',
        close:   'Close',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'Sign-in required',
        forbidden:     'You do not have permission for this',
        duplicate:     'This record already exists',
        overlapping_shift: 'An entry already exists for this time — the cycle overlaps another one. Check start and end.',
        too_many_attempts: 'Too many wrong attempts. Try again in 5 minutes.',
        on_add:        'Error while adding',
        on_edit:       'Error while updating',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully updated',
    },
    validation: {
        required: 'This field is required',
        email:    'Invalid email address',
    },
}
